module.exports = __webpack_public_path__ + "img/B_planname.5f2f60f3.png";